import React from 'react';
import PropTypes from 'prop-types';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import format from 'string-template';

import { LoadingButton } from '../../../../../components/Button';
import { formatRecipientCount } from '../../utils/formatRecipientCount';
import texts from '../../texts.json';

const SendCTA = ({
  isReady,
  isPreviewLoading,
  recipientCount,
  isCapped,
  isSubmitting,
  onClick,
}) => {
  let label;
  if (isSubmitting) {
    label = texts.sidePanel.send.submitting;
  } else if (isReady || isPreviewLoading) {
    label = format(texts.sidePanel.send.ready, { count: formatRecipientCount(recipientCount, isCapped) });
  } else {
    label = texts.sidePanel.send.incomplete;
  }

  return (
    <LoadingButton
      full
      isLoading={isSubmitting}
      disabled={!isReady}
      startIcon={<SendRoundedIcon style={{ fontSize: 16, marginRight: 8 }} />}
      onClick={onClick}
    >
      {label}
    </LoadingButton>
  );
};

SendCTA.propTypes = {
  isReady: PropTypes.bool.isRequired,
  isPreviewLoading: PropTypes.bool,
  recipientCount: PropTypes.number.isRequired,
  isCapped: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SendCTA.defaultProps = { isPreviewLoading: false, isCapped: false, isSubmitting: false };

export default SendCTA;
